import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessagesService } from '@bitapp-srl/ngb-messages';
import { Global } from '../../global';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {
  returnUrl: string;
  loading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private messagesService: MessagesService,
    private authenticationService: AuthenticationService
  ) {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/app';
  }

  ngOnInit(): void {
    this.checkAndNavigate();
  }

  reload(): void {
    this.loading = true;
    this.authenticationService.fetchUserData$().subscribe(
      () => {
        this.checkAndNavigate();
        this.endedLoading();
      },
      () => {
        this.checkAndNavigate();
        this.endedLoading();
      }
    );
  }

  checkAndNavigate(): void {
    if (!Global.isInMaintenanceMode) {
      this.messagesService.refresh();
      this.router.navigate([this.returnUrl]);
    }
  }

  endedLoading(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}
